/**
 * Resource danh sách điều chỉnh kinh phí thu
 * ntduong2 26/4/2023
 */
export default {
  Title: 'Điều chỉnh kinh phí thu',
  DetailTitle: 'Điều chỉnh kinh phí thu',
  BudgetSource: 'Nguồn',
  BankCode: 'Mã KBNN',
  BankCodeTitle: 'Mã kho bạc Nhà nước',
  Description: 'Diễn giải',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  AdjustDate: 'Ngày ĐC',
  AdjustDateTitle: 'Ngày điều chỉnh',
  AdjustNo: 'Số ĐC',
  AdjustNoTitle: 'Số điều chỉnh',
};
